// extracted by mini-css-extract-plugin
export default {"root":"_1IRW7PNg","spinner":"wFhA8qbn","rounded":"_2ZAkVmfU","emptyTip":"_26Je8_j2","noUrl":"_29HnrfZt"};